

// const affixTopPromise = (delayMsec) => {
//     // Deferred promise for affixTop func
//     const affixTop = (() => {
//         let resolve;
//         const promise = new Promise((res) => {
//             resolve = res;
//         });
//         return { promise, resolve };
//     })();
//
//     const oldAffix = window.affixTop;
//
//     window.affixTop = () => {
//         oldAffix();
//         affixTop.resolve('affix');
//     };
//
//     const shortDelay = (mSec) => new Promise((resolve) => {
//         setTimeout(resolve, mSec, 'delay');
//     });
//
//     return Promise.race([shortDelay(delayMsec), affixTop.promise])
//         .then((/* value */) => {
//             // console.log(value);
//             return loadNewsClient();
//         });
// };

const getNews = (params) => {
    // console.log(params)
    let hasShown = false;

    return (observer) => {
        if (hasShown) return;

        const loadNewsClient = async () => await import(
            /* webpackChunkName: "inbox-news-2026" */
            'news-client' // prod
            // '../../../../../../vendor/inbox/news-client/src/App' // dev
        );

        const getNewsModule = loadNewsClient();

        getNewsModule
            .then(({ PortalApp }) => {
                try {
                    PortalApp(params);
                    hasShown = true;
                    observer.unobserve(params.appContainer);
                } catch (err) {
                    console.log(err);
                }
            }).catch((err) => {
                console.log(err);
            });
    };
};

export default () => {
    const { inx } = window;
    if (!inx || !inx.newsClient) return;

    const { newsClient } = inx;
    const observerCallback = (entries, observer) => {
        const { isIntersecting } = entries[0];
        if (isIntersecting) {
            getNews(newsClient)(observer);
        }
    };

    const intObserver = new IntersectionObserver(observerCallback, {
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.01,
    });
    intObserver.observe(newsClient.appContainer);
};
